import * as jose from 'jose';
import { Outlet, useLocation } from 'react-router-dom';
import { useEvent, useUnit } from 'effector-react';
import { useEffect } from 'react';
import { ConfigProvider, Layout, Spin } from 'antd';
import localeRu from 'antd/locale/ru_RU';
import localeKz from 'antd/locale/kk_KZ';
import localeEng from 'antd/locale/en_US';
import localeCn from 'antd/locale/zh_CN';
import {
  $authStatus,
  $language,
  setAuthStatusEv,
} from '../../models/authModel/index.js';
import { getAnalyticsDataFx } from '../../models/organizationsModel/index.js';
import { getNMPDataDupFx, getNMPDataFx } from '../../models/mgpModel/index.js';
import { getOverviewDataFx } from '../../models/overviewModel/index.js';
import { getRawDataFx } from '../../models/globalModel/index.js';
import { getDictionariesFx } from '../../models/dictionariesModel/index.js';

const localeDict = {
  ru: localeRu,
  kz: localeKz,
  en: localeEng,
  cn: localeCn,
};

export default function ContentContainerPublic() {
  const location = useLocation();
  const language = useUnit($language);
  const authStatus = useUnit($authStatus);
  const setAuth = useEvent(setAuthStatusEv);

  useEffect(() => {
    const token = location.search.includes('token')
      ? location.search?.split('=')?.at(-1)
      : null;

    async function verify() {
      try {
        const publicKey = await jose.importSPKI(__PUBLIC_TOKEN__, 'RS256');
        await jose.jwtVerify(token, publicKey, {
          issuer: 'ab',
          audience: 'ckb',
        });
        setAuth(true);
        localStorage.setItem('public_auth_token', token);
      } catch (e) {
        console.error('token validation error', e);
        setAuth(false);
      }
    }

    if (!authStatus && !!token) {
      verify().then(() => true);
    }
  }, [location, authStatus]);

  useEffect(() => {
    if (authStatus) {
      getRawDataFx();
      getDictionariesFx();
    }
  }, [authStatus]);

  const isGlobalLoading = useUnit(getRawDataFx.pending);
  const isOverviewLoading = useUnit(getOverviewDataFx.pending);
  const isNMPLoading = useUnit(getNMPDataFx.pending);
  const isNMPLoadingDup = useUnit(getNMPDataDupFx.pending);
  const analyticsLoading = useUnit(getAnalyticsDataFx.pending);

  const isLoading =
    isGlobalLoading ||
    isOverviewLoading ||
    isNMPLoading ||
    isNMPLoadingDup ||
    analyticsLoading ||
    !authStatus;

  return (
    <ConfigProvider locale={localeDict[language]}>
      <Spin spinning={isLoading} tip="Загружаем данные..." size="large">
        <Layout className="layout_container">
          <Layout.Content style={{ height: '100%' }} className="content">
            <Outlet />
          </Layout.Content>
        </Layout>
      </Spin>
    </ConfigProvider>
  );
}
